export default {
  title: '职位',
  tab: '职位'
}
